import { render, staticRenderFns } from "./PopupAnnouncement.vue?vue&type=template&id=de005c0a"
import script from "./PopupAnnouncement.vue?vue&type=script&lang=js"
export * from "./PopupAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./PopupAnnouncement.vue?vue&type=style&index=0&id=de005c0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports